import { Component, Inject, OnInit } from '@angular/core';
import { MAT_DIALOG_DATA } from '@angular/material/dialog';


@Component({
    selector: 'ah-invalid-sub-department-modal',
    templateUrl: './invalid-sub-department-modal.component.html',
    styleUrls: ['./invalid-sub-department-modal.component.scss'],
    standalone: false
})
export class InvalidSubDepartmentModalComponent implements OnInit {

  message1 = '';
  title: string;
  modalMessage: string;
  unmatchedDepartments = [];
  unmatchedSubDepartments = [];
  constructor(@Inject(MAT_DIALOG_DATA) private data: any) { }

  ngOnInit(): void {
    this.title = this.data.title;
    this.unmatchedDepartments = this.data.unmatchedDepartments;
    this.unmatchedSubDepartments = this.data.unmatchedSubDepartments;
  }

}
